module.exports = __webpack_public_path__ + "media/components/Shared/CustomSelect/arrow_down-dark-18f2ff6fe7fac9233e2f967f8dfc1cad.png";